export const ACCOUNTS_PATH = "accounts";
